import { obtenerHeadersMagno, getErrorMessage } from "./auth";
import { magnoApi } from "./axios";

interface dataResponse<T> {
  data: T;
}

interface MagnoResponseVerifyI {
  claveAcceso: string;
  estado: string;
  estadoLocal: string;
  existeEnSri: boolean;
  fechaAutorizacion: Date;
  numeroAutorizacion: string;
  sincronizado: boolean;
}
export const magnoVerificarDocumento = async (
  claveAcceso: string,
): Promise<MagnoResponseVerifyI> => {
  try {
    const headers = await obtenerHeadersMagno();
    const { data } = await magnoApi.get<MagnoResponseVerifyI>(
      `/sri/verificar/${claveAcceso}`,
      {
        headers,
      },
    );
    return data;
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
};

interface MangoSincronizarSriI {
  procesados:number
  actualizados:number; 
  reintentados:number; 
  errores:number; 
  detalle:any;
}

export const magnoSincronizarSri = async (rucEmisor: string): Promise<MangoSincronizarSriI> => {
  try {
    const payload = {
      estados: ["PENDIENTE", "EN_PROCESO", "DEVUELTA"],
      reintentar: false,
      limite: 50,
      rucEmisor,
    };
    const headers = await obtenerHeadersMagno();
    const { data } = await magnoApi.post<MangoSincronizarSriI>(
      `/sri/sincronizar/`,
      payload,
      {
        headers,
      },
    );
    return data;
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
};

export const magnoAnularDocumento = async (claveAcceso: string) => {
  try {
    const headers = await obtenerHeadersMagno();
    const { data } = await magnoApi.patch(
      `/sri/comprobantes/${claveAcceso}/anular`,
      // Sin este flag, Magno exige que el SRI responda "ANULADO" en la
      // consulta en vivo, algo que casi nunca ocurre: un comprobante ya
      // anulado en el portal del SRI normalmente responde "no existe", no
      // "ANULADO". Con el flag, Magno reconcilia su estado local si el SRI
      // ya no reconoce el comprobante como vigente.
      { confirmarAnulacionManual: true },
      { headers },
    );
    return data;
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
};

export const magnoDownloadXml = async (claveAcceso: string) => {
  try {
    const headers = await obtenerHeadersMagno();
    const { data } = await magnoApi.get(
      `/sri/comprobantes/${claveAcceso}/xml`,
      {
        headers,
      },
    );
    return data;
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
};
